setLiveAccessChatBlockedUsersError